import { useState } from 'react'
import type { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

// Legacy wrapped Blueprint's Button+Collapse; the collapse was only ever a mobile affordance —
// desktop CSS forced it permanently open — so plain markup plus a display toggle reproduces it
// (see .table-of-contents in legal.scss). `children` is the page's own top-level anchor.
export function TableOfContents({
  children,
  sections,
}: {
  children?: ReactNode
  sections: ReadonlyArray<{ id: number; hash: string; text: string }>
}) {
  const { hash } = useLocation()

  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="table-of-contents">
      <button type="button" className="toc-toggle" onClick={() => setIsOpen((x) => !x)}>
        On this page
        <span aria-hidden="true">{isOpen ? '⌃' : '⌄'}</span>
      </button>

      <div className={`toc-body${isOpen ? ' isOpen' : ''}`}>
        <nav className={isOpen ? 'isOpen' : ''}>
          {children}

          <ol>
            {sections.map((section) => (
              <li key={section.id}>
                <a href={section.hash} className={section.hash === hash ? 'active' : ''}>
                  {section.text}
                </a>
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  )
}
